module.exports = __webpack_public_path__ + "img/manisha.f9692888.jpg";